import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const SOURCES = {
  SOURCE_UNKNOWN: 0, // Unknown
  SOURCE_INVITE: 1, // Buyer themselves have invited the seller directly
  SOURCE_BLAST: 2, // Seller was invited via a blast
  SOURCE_DIY: 3, // Seller was invited through "contact" via a public profile
  SOURCE_REFERRAL: 4, // Seller was referred by another seller
};

export const ASSIGNMENT_INVITE = {
  SOURCES,
};

const AssignmentInvite = ShModel.extend({
  // attributes
  createdAt: attr('date'),
  source: attr('number'),
  updatedAt: attr('date'),
  userNotifiedCount: attr('number'),

  // relationships
  assignment: belongsTo('assignment', { async: false }),
  user: belongsTo('user', { async: false }),
});

export default AssignmentInvite;
